// File: /src/components/dashboard/IndicatorsSection.js

import React from 'react';
import {
	FaMoneyBillWave,
	FaDollarSign,
	FaEuroSign,
	FaPoundSign,
	FaBitcoin,
	FaEthereum,
} from 'react-icons/fa';
import { useDashboardIndicators } from '../../contexts/DashboardIndicatorsContext';

const IndicatorRow = ({
	icon: Icon,
	label,
	value,
	trend,
	isCrypto = false,
	fractionDigits = 2,
}) => {
	const formatCurrency = (val) =>
		val.toLocaleString('pt-BR', {
			minimumFractionDigits: isCrypto ? 2 : fractionDigits,
			maximumFractionDigits: isCrypto ? 6 : fractionDigits,
		});

	const trendClass =
		trend > 0 ? 'trend-up' : trend < 0 ? 'trend-down' : 'neutral';
	const trendSymbol = trend > 0 ? '↑' : trend < 0 ? '↓' : '-';

	return (
		<div className="indicator-item">
			<span className="indicator-name">
				<Icon /> {label}
			</span>
			<div>
				<span className="indicator-value">{formatCurrency(value)}</span>
				<span className={`indicator-trend ${trendClass}`}>
					{trendSymbol}
				</span>
			</div>
		</div>
	);
};

const IndicatorsSection = () => {
	const { indicators, loading } = useDashboardIndicators();

	return (
		<div className="financial-indicators">
			<div className="indicator-header">
				<div className="card-icon">
					<FaMoneyBillWave size={16} />
				</div>
				<h2>Indicadores Financeiros</h2>
			</div>
			{loading ? (
				<p>Carregando indicadores...</p>
			) : (
				<div className="indicator-list">
					<IndicatorRow
						icon={FaDollarSign}
						label="USD"
						value={indicators.dollar.value}
						trend={indicators.dollar.trend}
						fractionDigits={4}
					/>
					<IndicatorRow
						icon={FaEuroSign}
						label="EUR"
						value={indicators.euro.value}
						trend={indicators.euro.trend}
						fractionDigits={4}
					/>
					<IndicatorRow
						icon={FaPoundSign}
						label="GBP"
						value={indicators.pound.value}
						trend={indicators.pound.trend}
						fractionDigits={4}
					/>
					<IndicatorRow
						icon={FaBitcoin}
						label="BTC"
						value={indicators.bitcoin.value}
						trend={indicators.bitcoin.trend}
						isCrypto
					/>
					<IndicatorRow
						icon={FaEthereum}
						label="ETH"
						value={indicators.ethereum.value}
						trend={indicators.ethereum.trend}
						isCrypto
					/>
				</div>
			)}
		</div>
	);
};

export default IndicatorsSection;
